import React, { useMemo } from 'react';
import styled from 'styled-components';

const Style = styled.div`
  .main-container {
    display: flex;
    max-width: 125px;
    min-width: 100px;

    .bar-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;

      .bar {
        height: 8px;
        width: 100%;
        border-radius: 100px;
        overflow: hidden;

        div {
          height: 8px;
          background: red;
          border-top-right-radius: 100px;
          border-bottom-right-radius: 100px;
        }
      } 
    }

    span {
      font-weight: 700;
      font-size: 13px;
      width: 45px;
      padding-left: 7px;
    }
  }
`;

const CustomProgressBar = ({
  percent = 0,
}) => {
  const value = useMemo(() => {
    switch (true) {
      case percent < 0:
        return 0;
      case percent > 100:
        return 100
      default:
        return percent;
    }
  }, [percent]);

  const [color, textColor, background] = useMemo(() => {
    switch (value) {
      case 0:
        return ['', '#FF4D4F', 'rgba(255, 77, 79, 0.2)'];
      case 100:
        return ['#52C41A', '#52C41A', ''];
      default:
        return ['var(--mmt-primary-70)', '#595959', '#D1E9FF'];
    }
  }, [value]);

  return (
    <Style>
      <div className="main-container">
        <div className="bar-container">
          <div className="bar" style={{ background }}>
            <div style={{ width: `${value}%`, background: color }} />
          </div>
        </div>
        <span style={{ color: textColor }}>{value}%</span>
      </div>
    </Style>
  );
};

export default CustomProgressBar;
